import * as React from "react";
import Typography from "@mui/material/Typography";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ApartmentIcon from "@mui/icons-material/Apartment"; // Default placeholder icon
import "./VendorInfoCard.css";
import CWCImage from "../../assets/image.png";

export interface VendorInfo {
  logoIcon?: React.ReactElement; // Allow passing a custom icon/image component
  companyName: string;
  vendorNo: string;
  address: string;
  panNoLabel?: string;
  panNoValue?: string;
  bankKeyLabel?: string;
  bankKeyValue?: string;
  gstLabel?: string;
  gstValue?: string;
  accountNoLabel?: string;
  accountNoValue?: string;
}

interface VendorCardProps {
  vendor: VendorInfo;
}

const VendorInfoCard: React.FC<VendorCardProps> = ({ vendor }) => {
  const panLabel = vendor.panNoLabel ?? "Pan No.";
  const bankKeyLabelText = vendor.bankKeyLabel ?? "Bank Key";
  const gstLabelText = vendor.gstLabel ?? "GST";
  const accountNoLabelText = vendor.accountNoLabel ?? "A/C";

  // React.useEffect(()=>{
  //   localStorage.setItem("vendor_code", vendor.vendorNo);
  //   localStorage.setItem("vendor_name", vendor.companyName);
  // },[]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        columnGap: 220,
        rowGap: 20,
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <div className="vendor-basic-details">
        <Typography variant="h6" component="div" fontWeight="bold" style={{ color: "#4393E4" }}>
          {vendor.companyName}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Vender No. {vendor.vendorNo} {/* Corrected from Vender to Vendor if intended */}
        </Typography>

        <div className="vendor-location">
          <LocationOnIcon
            sx={{
              mr: 0.5,
              color: "text.secondary",
              fontSize: "1.2rem",
              mt: "3px",
            }}
          />
          <Typography variant="body2" color="text.secondary">
            {vendor.address}
          </Typography>
        </div>
      </div>
      <div className="vendor-other-details">
        {(vendor.panNoValue || vendor.panNoLabel === "Pan No.") && (
          <Typography variant="caption" color="text.secondary">
            <b>{panLabel}</b>
            {vendor.panNoValue ? `: ${vendor.panNoValue}` : ""}
          </Typography>
        )}
        {(vendor.bankKeyValue || vendor.bankKeyLabel === "Bank Key") && (
          <Typography variant="caption" color="text.secondary">
            <b>{bankKeyLabelText}</b>
            {vendor.bankKeyValue ? `: ${vendor.bankKeyValue}` : ""}
          </Typography>
        )}
        {(vendor.gstValue || vendor.gstLabel === "GST") && (
          <Typography variant="caption" color="text.secondary">
            <b>{gstLabelText}</b>
            {vendor.gstValue ? `: ${vendor.gstValue}` : ""}
          </Typography>
        )}
        {(vendor.accountNoValue || vendor.accountNoLabel === "A/C") && (
          <Typography variant="caption" color="text.secondary">
            <b>{accountNoLabelText}</b>
            {vendor.accountNoValue ? `: ${vendor.accountNoValue}` : ""}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default VendorInfoCard;
